
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pair-with-bundles').forEach(function (root) {
    var tabs = root.querySelectorAll('.pwb-tab');
    var panels = root.querySelectorAll('.pwb-panel');

    // 텍스트가 없는 .pwb-tab 숨김
    tabs.forEach(function (tab) {
      if (tab.textContent.trim() === '') {
        tab.classList.add('displaynone');
      }
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-pwb-tab');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        tab.classList.add('is-active');

        panels.forEach(function (panel) {
          panel.classList.toggle(
            'is-active',
            panel.getAttribute('data-pwb-panel') === target
          );
        });
      });
    });
  });
});
